<template>
  <v-menu
    v-model="datePicker"
    :close-on-content-click="false"
    transition="scale-transition"
    max-width="290"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-mask="dateMask"
        @keydown="setInputDate"
        :value="computedDateFormatted"
        :placeholder="$t('date-placeholder')"
        :prepend-inner-icon="mdiCalendarOutline"
        :label="$t('date')"
        :rules="dateRules"
        autocomplete="off"
        v-on="on"
        outlined
        name="no-autocomplete"
      ></v-text-field>
    </template>
    <v-date-picker @change="setPickerDate" locale="ru" no-title></v-date-picker>
  </v-menu>
</template>

<script>
import { mask } from "vue-the-mask";
import { mdiCalendarOutline } from "@mdi/js";

export default {
  name: "FieldDate",
  props: { initialDate: String },
  directives: { mask },
  data: (vm) => ({
    datePicker: false,
    date: null,
    dateRules: [
      (v) => !!v || vm.$t("field-requied"),
      (v) =>
        vm.$dayjs(v, "DD.MM.YYYY").format("DD.MM.YYYY") === v ||
        vm.$t("date-invalid"),
    ],
    dateMask: "##.##.####",
    mdiCalendarOutline,
  }),
  computed: {
    computedDateFormatted() {
      if (this.date) {
        this.$emit("attrUpdate", this.date);
        return this.date;
      } else if (this.initialDate) {
        return this.$dayjs.unix(this.initialDate).format("DD.MM.YYYY");
      }
    },
  },
  methods: {
    setPickerDate(value) {
      this.date = this.$dayjs(value).format("DD.MM.YYYY");
      this.datePicker = false;
    },
    setInputDate(event) {
      this.date = event.target.value;
      this.datePicker = false;
    },
  },
};
</script>
